const selectfield = {
    borderColor: { value: '{components.fieldcontrol.borderColor}' },
    color: { value: '{components.fieldcontrol.color}' },
    flexDirection: {
        value: 'column',
    },
    fontSize: { value: '{components.fieldcontrol.fontSize}' },
    _focus: {
        borderColor: { value: '{components.fieldcontrol._focus.borderColor}' },
    },
    label: {
        color: { value: '{components.field.label.color}' },
    },
};

export { selectfield };
